import { customFetch } from "../../utils/http";

export const getProvinces = async (search: string) => {
  const queryParams = new URLSearchParams();
  if (search) queryParams.set("search", search);
  return await customFetch(`v1/regional/province?${queryParams}`, {
    method: "GET",
  });
};

export const getRegencies = async (search: string, provinceId?: string) => {
  const queryParams = new URLSearchParams();
  if (search) queryParams.set("search", search);
  if (provinceId) queryParams.set("province_id", provinceId);
  return await customFetch(`v1/regional/regency?${queryParams}`, {
    method: "GET",
  });
};

export const getDistricts = async (search: string, regencyId?: string) => {
  const queryParams = new URLSearchParams();
  if (search) queryParams.set("search", search);
  if (regencyId) queryParams.set("regency_id", regencyId);
  return await customFetch(`v1/regional/district?${queryParams}`, {
    method: "GET",
  });
};

export const getVillages = async (search: string, districtId?: string) => {
  const queryParams = new URLSearchParams();
  if (search) queryParams.set("search", search);
  if (districtId) queryParams.set("district_id", districtId);
  return await customFetch(`v1/regional/village?${queryParams}`, {
    method: "GET",
  });
};
